import { scrollIntoView } from "@app/utils/scrollIntoView"
import { getCurrentAndZCodeQuantities } from "@app/utils/z-codes"
import { dispatchCartUpdate } from "@app/utils/cart"
import { EVENT_CART_MINI_OPEN } from "@app/components/cart"

export const getCart = async () => {
  const res = await fetch(`${window.Shopify.routes.root}cart.json`);
  return await res.json();
};

export const updateCartItem = async (data: { id: string | number; quantity: number }) => {
  const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await res.json();
};

export const addToCart = async (data: {
  items: {
    id: string | number;
    quantity: number;
    properties?: { [key: string]: string };
  }[];
}) => {
  const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await res.json();
};

export const addToCartWithZCodes = async (
  quantityToAdd: number,
  variantId: string,
  size?: string,
  properties?: { [key: string ]: string } | null,
  zVariantId?: string,
  zSize?: string,
  zQuantity?: number
) => {
  let errorMessage = null

  try {
    const matchedSizeText = size === zSize
    const variants = getCurrentAndZCodeQuantities(quantityToAdd, variantId, zVariantId, zQuantity)

    let missedQuantityDueToError = 0
    let addErrorsEncountered = false

    for (const variant of variants) {
      // Add quantity that was missed in previous adds
      const quantityToAdd = variant.quantity + missedQuantityDueToError
      if (quantityToAdd === 0) {
        continue
      }

      const addDisclaimer = variant.isZCode && !matchedSizeText && window?.zCodeCheckoutDisclaimer
      const res = await addToCart({
        items: [
          {
            id: variant.id,
            quantity: quantityToAdd,
            properties: {
              ...(properties && { ...properties }),
              // Z-code properties
              ...(variant.isZCode && {
                _nonZVariantId: variantId,
                _nonZVariantSize: size,
              }),
              ...(!variant.isZCode && zVariantId ? { _zVariantId: zVariantId } : {}),
              ...(addDisclaimer && { Note: window?.zCodeCheckoutDisclaimer?.replace("[size]", size || "") })
            },
          },
        ],
      })

      if (res.status === 422) {
        // Only show error if non Z-code throws an error
        if (!variant.isZCode) {
          addErrorsEncountered = true
          errorMessage = res.description
        }
        missedQuantityDueToError++ // Track un-added quantity
      }
    }

    const cart = await getCart();
    if (cart?.item_count) {
      dispatchCartUpdate(cart)
    }

    if (!addErrorsEncountered) {
      document.dispatchEvent(new CustomEvent(EVENT_CART_MINI_OPEN));
    }

  } catch (error) {
    console.error(error);
    errorMessage = "Something went wrong"
  }

  return errorMessage
};

export const addDiscountCode = async (discountCode: string) => {
  // window.location.href = `/discount/${discountCode}`
  await fetch(`/discount/${discountCode}`);
};
